import { Link } from 'react-router-dom';
import {
  Building2,
  Dumbbell,
  FlaskConical,
  HeartPulse,
  Pill,
  Salad,
  Star,
  MapPin,
  CalendarCheck,
  BarChart3,
  Users,
  Brain,
  CheckCircle,
  ArrowRight,
  Shield,
  BadgeCheck,
  TrendingUp,
  Sparkles,
  ChevronRight,
} from 'lucide-react';

const centerTypes = [
  { icon: Dumbbell, label: 'Sală de Sport / Centru Fitness', color: 'text-orange-600', bg: 'bg-orange-50' },
  { icon: HeartPulse, label: 'Centru CrossFit & HIIT', color: 'text-red-600', bg: 'bg-red-50' },
  { icon: Salad, label: 'Studio Nutriție Sportivă', color: 'text-green-600', bg: 'bg-green-50' },
  { icon: Building2, label: 'Centru Wellness & Recuperare', color: 'text-blue-600', bg: 'bg-blue-50' },
  { icon: Pill, label: 'Magazin Suplimente Sportive', color: 'text-purple-600', bg: 'bg-purple-50' },
  { icon: FlaskConical, label: 'Studio Yoga / Pilates', color: 'text-cyan-600', bg: 'bg-cyan-50' },
];


const features = [
  {
    icon: Building2,
    title: 'Pagină Profil Business',
    desc: 'Nume, descriere, specialități, poze din centru, adresă și hartă interactivă direct în FII FIT.',
    color: 'text-blue-600',
    bg: 'bg-blue-50',
    border: 'border-blue-100',
  },
  {
    icon: Users,
    title: 'Echipă de Specialiști',
    desc: 'Listează fiecare antrenor sau specialist cu bio, specializare, foto și program de lucru.',

    color: 'text-teal-600',
    bg: 'bg-teal-50',
    border: 'border-teal-100',
  },
  {
    icon: CalendarCheck,
    title: 'Programări Online',
    desc: 'Clienții se pot programa direct din aplicație, fără apeluri telefonice.',

    color: 'text-green-600',
    bg: 'bg-green-50',
    border: 'border-green-100',
  },
  {
    icon: Star,
    title: 'Review-uri Verificate',
    desc: 'Recenzii autentice de la utilizatorii FII FIT care au consultat centrul tău.',
    color: 'text-yellow-600',
    bg: 'bg-yellow-50',
    border: 'border-yellow-100',
  },
  {
    icon: BarChart3,
    title: 'Statistici în Timp Real',
    desc: 'Vizualizări, favorite, programări — toate datele relevante într-un singur dashboard.',
    color: 'text-purple-600',
    bg: 'bg-purple-50',
    border: 'border-purple-100',
  },
  {
    icon: Brain,
    title: 'Recomandări AI',
    desc: 'Centrul tău apare recomandat utilizatorilor cu obiective de fitness compatibile cu specialitatea ta.',
    color: 'text-indigo-600',
    bg: 'bg-indigo-50',
    border: 'border-indigo-100',
  },
];

const plans = [
  {
    name: 'Basic',
    tagline: 'Perfect pentru debut în mediul digital',
    price: '149',
    popular: false,
    color: 'border-gray-200',
    btnClass: 'bg-gray-900 hover:bg-gray-800 text-white',
    features: [
      'Pagină profil business completă',
      'Până la 3 antrenori/specialiști listați',

      'Apariție în Harta Specialiști',
      'Buton contact direct',
      'Badge „Verificat FII FIT"',
    ],
    cta: 'Începe gratuit 30 zile',
    ctaStyle: 'border border-gray-300 text-gray-800 hover:bg-gray-50',
  },
  {
    name: 'Pro',
    tagline: 'Creștere accelerată cu programări online',
    price: '349',
    popular: true,
    color: 'border-teal-500',
    btnClass: 'bg-teal-600 hover:bg-teal-700 text-white',
    features: [
      'Tot ce include Basic',
      'Specialiști nelimitați',
      'Programări online integrate',
      'Postări & Noutăți (articole, promo)',
      'Statistici pagină în timp real',
      'Poziționare prioritară în hartă',
      'Export date programări (CSV)',
    ],
    cta: 'Alege Pro',
    ctaStyle: 'bg-teal-600 hover:bg-teal-700 text-white',
  },
  {
    name: 'Premium',
    tagline: 'Vizibilitate maximă cu AI targeting',
    price: '699',
    popular: false,
    color: 'border-indigo-300',
    btnClass: 'bg-indigo-600 hover:bg-indigo-700 text-white',
    features: [
      'Tot ce include Pro',
      'Recomandări AI targetate (obiective fitness)',
      'Banner promoțional în aplicație',
      'Notificări push pentru utilizatori relevanți',
      'Analiză competitivă în zonă',
      'Manager de cont dedicat',
      'Integrare CRM extern',
    ],
    cta: 'Alege Premium',
    ctaStyle: 'border border-indigo-300 text-indigo-700 hover:bg-indigo-50',
  },
];

const testimonials = [
  {
    quote: 'În prima lună cu FII FIT Business Pro am primit 43 de programări noi. ROI ul a depășit așteptările.',
    name: 'Dr. Mihai Georgescu',
    role: 'Director, RecovFit Cluj',

    initials: 'MG',
    plan: 'Pro',
    planColor: 'bg-teal-100 text-teal-700',
    rating: 5,
  },
  {
    quote: 'Recomandările AI targetate ne-au adus exact clienții potriviți — oameni cu obiective clare de transformare.',
    name: 'Irina Florescu',
    role: 'Manager, NutriFit București',

    initials: 'IF',
    plan: 'Premium',
    planColor: 'bg-indigo-100 text-indigo-700',
    rating: 5,
  },
  {
    quote: 'Pagina noastră arată profesional și primim recenzii verificate săptămânal. Foarte ușor de gestionat.',
    name: 'Andrei Vasile',
    role: 'Proprietar, FitnActive Timișoara',
    initials: 'AV',
    plan: 'Basic',
    planColor: 'bg-gray-100 text-gray-700',
    rating: 4,
  },
];

export default function FiiFitBusinessPage() {
  return (
    <div className="min-h-screen bg-white">
      {/* ── Navbar ─────────────────────────────────────────────────────── */}
      <nav className="bg-white border-b border-gray-100 sticky top-0 z-50 shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            {/* Logo */}
            <Link to="/" className="flex items-center space-x-2">
              <div className="w-9 h-9 bg-teal-600 rounded-xl flex items-center justify-center shadow">
                <Dumbbell className="w-5 h-5 text-white" />
              </div>
              <div className="flex flex-col leading-none">
                <span className="text-lg font-extrabold text-gray-900">FII FIT</span>
                <span className="text-[10px] font-bold text-teal-600 uppercase tracking-widest -mt-0.5">Business</span>
              </div>
            </Link>

            {/* Nav links */}
            <div className="hidden md:flex items-center space-x-6 text-sm font-medium text-gray-600">
              <a href="#features" className="hover:text-teal-600 transition-colors">Funcționalități</a>
              <a href="#pricing" className="hover:text-teal-600 transition-colors">Prețuri</a>
              <a href="#testimonials" className="hover:text-teal-600 transition-colors">Parteneri</a>
              <Link to="/login" className="hover:text-teal-600 transition-colors">Conectare</Link>
              <Link
                to="/business/register"
                className="bg-teal-600 text-white px-5 py-2 rounded-xl hover:bg-teal-700 transition-all shadow-md font-semibold"
              >
                Înregistrează centrul →
              </Link>
            </div>

            {/* Mobile CTA */}
            <div className="md:hidden">
              <Link
                to="/business/register"
                className="bg-teal-600 text-white px-4 py-2 rounded-lg text-sm font-semibold"
              >
                Înregistrează-te
              </Link>
            </div>
          </div>
        </div>
      </nav>

      {/* ── Hero ───────────────────────────────────────────────────────── */}
      <section className="relative overflow-hidden bg-gradient-to-br from-slate-50 via-white to-teal-50 pt-20 pb-28">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 bg-teal-50 border border-teal-200 text-teal-700 px-5 py-2 rounded-full text-sm font-semibold mb-8 shadow-sm">
            <Sparkles className="w-4 h-4" />
            FII FIT Business — Nouă funcționalitate
          </div>

          <h1 className="text-5xl md:text-6xl font-extrabold text-gray-900 mb-6 leading-tight">
            Sala ta de fitness,{' '}
            <span className="text-teal-600">vizibilă</span>
            <br />
            acolo unde contează
          </h1>

          <p className="text-xl text-gray-600 mb-10 max-w-2xl mx-auto leading-relaxed">
            Creează un profil business în aplicația FII FIT și fii descoperit de mii de
            pasionați de fitness din zona ta. Programări online, review-uri verificate
            și statistici detaliate — totul într-un singur loc.
          </p>


          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-14">
            <Link
              to="/business/register"
              className="flex items-center gap-2 bg-teal-600 text-white px-8 py-4 rounded-2xl font-bold hover:bg-teal-700 transition-all shadow-xl hover:shadow-2xl text-lg"
            >
              Înregistrează centrul tău
              <ArrowRight className="w-5 h-5" />
            </Link>
            <Link
              to="/specialists"
              className="flex items-center gap-2 border-2 border-gray-300 text-gray-700 px-8 py-4 rounded-2xl font-bold hover:border-teal-500 hover:text-teal-600 transition-all text-lg"
            >
              <MapPin className="w-5 h-5" />
              Vezi exemplu profil
            </Link>
          </div>

          {/* Trust bar */}
          <div className="flex flex-wrap justify-center gap-6 text-sm text-gray-500">
            <div className="flex items-center gap-2">
              <CheckCircle className="w-4 h-4 text-teal-500" />
              340+ centre înregistrate
            </div>
            <div className="flex items-center gap-2">
              <CheckCircle className="w-4 h-4 text-teal-500" />
              12.000+ programări lunare
            </div>
            <div className="flex items-center gap-2">
              <BadgeCheck className="w-4 h-4 text-teal-500" />
              Verificat de FII FIT
            </div>
            <div className="flex items-center gap-2">
              <Shield className="w-4 h-4 text-teal-500" />
              Fără comision per programare
            </div>
          </div>
        </div>

        {/* BG decoration */}
        <div className="absolute top-0 right-0 -z-10 opacity-20">
          <div className="w-80 h-80 bg-teal-400 rounded-full blur-3xl"></div>
        </div>
        <div className="absolute bottom-0 left-0 -z-10 opacity-20">
          <div className="w-80 h-80 bg-cyan-400 rounded-full blur-3xl"></div>
        </div>
      </section>

      {/* ── Cine se poate înregistra ───────────────────────────────────── */}
      <section className="py-20 bg-white">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <p className="text-center text-xs font-bold text-gray-400 uppercase tracking-widest mb-10">
            Cine se poate înregistra
          </p>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
            {centerTypes.map((ct) => (
              <div
                key={ct.label}
                className={`flex flex-col items-center gap-3 p-5 rounded-2xl ${ct.bg} border border-transparent hover:border-gray-200 transition-all cursor-default`}
              >
                <ct.icon className={`w-8 h-8 ${ct.color}`} />
                <span className="text-xs font-semibold text-gray-700 text-center leading-tight">{ct.label}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── Features ───────────────────────────────────────────────────── */}
      <section id="features" className="py-24 bg-gradient-to-br from-gray-50 to-teal-50">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-extrabold text-gray-900 mb-4">
              Tot ce ai nevoie pentru a crește online
            </h2>
            <p className="text-lg text-teal-600 font-medium">
              Funcționalități construite special pentru profesioniștii din fitness și wellness din România.
            </p>

          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {features.map((f) => (
              <div
                key={f.title}
                className={`bg-white rounded-2xl p-7 border ${f.border} hover:shadow-lg transition-all`}
              >
                <div className={`w-12 h-12 ${f.bg} rounded-xl flex items-center justify-center mb-5`}>
                  <f.icon className={`w-6 h-6 ${f.color}`} />
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-2">{f.title}</h3>
                <p className="text-gray-600 text-sm leading-relaxed">{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── Pricing ────────────────────────────────────────────────────── */}
      <section id="pricing" className="py-24 bg-white">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-extrabold text-gray-900 mb-4">
              Pachete clare, fără surprize
            </h2>
            <p className="text-lg text-gray-600">
              Alege planul potrivit pentru centrul tău și scalează când ești gata.
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8 items-start">
            {plans.map((plan) => (
              <div
                key={plan.name}
                className={`relative rounded-2xl border-2 ${plan.color} bg-white overflow-visible shadow-sm hover:shadow-xl transition-all`}
              >
                {/* Popular badge */}
                {plan.popular && (
                  <div className="absolute -top-4 left-1/2 -translate-x-1/2 z-10">
                    <span className="bg-teal-600 text-white text-xs font-bold px-4 py-1.5 rounded-full shadow-md">
                      ⭐ Cel mai popular
                    </span>
                  </div>
                )}

                <div className="p-8 pt-10">
                  <h3 className="text-2xl font-extrabold text-gray-900 mb-1">{plan.name}</h3>
                  <p className="text-sm text-gray-500 mb-6">{plan.tagline}</p>

                  <div className="mb-8">
                    <span className="text-5xl font-extrabold text-gray-900">{plan.price}</span>
                    <span className="text-gray-500 ml-2">lei/lună</span>
                  </div>

                  <ul className="space-y-3 mb-8">
                    {plan.features.map((feat) => (
                      <li key={feat} className="flex items-start gap-2 text-sm text-gray-700">
                        <CheckCircle className="w-4 h-4 text-teal-500 flex-shrink-0 mt-0.5" />
                        {feat}
                      </li>
                    ))}
                  </ul>

                  <Link
                    to="/business/register"
                    className={`w-full block text-center py-3 px-6 rounded-xl font-bold transition-all ${plan.ctaStyle}`}
                  >
                    {plan.cta}
                    {plan.name === 'Basic' && (
                      <span className="block text-xs font-normal mt-0.5 opacity-70">→</span>
                    )}
                  </Link>
                </div>
              </div>
            ))}
          </div>

          <p className="text-center text-sm text-gray-400 mt-8">
            Toate planurile includ 30 de zile de probă gratuită. Fără card necesar.
          </p>
        </div>
      </section>

      {/* ── Testimonials ───────────────────────────────────────────────── */}
      <section id="testimonials" className="py-24 bg-gradient-to-br from-gray-50 to-teal-50">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-extrabold text-gray-900 mb-4">
              Ce spun partenerii noștri
            </h2>
            <p className="text-lg text-gray-600">
              Săli de fitness și studiouri care au ales FII FIT Business.
            </p>

          </div>

          <div className="grid md:grid-cols-3 gap-6">
            {testimonials.map((t) => (
              <div key={t.name} className="bg-white rounded-2xl p-7 shadow-sm border border-gray-100 hover:shadow-md transition-all">
                {/* Stars */}
                <div className="flex gap-1 mb-4">
                  {[...Array(5)].map((_, i) => (
                    <Star
                      key={i}
                      className={`w-4 h-4 ${i < t.rating ? 'text-yellow-400 fill-current' : 'text-gray-200'}`}
                    />
                  ))}
                </div>

                <p className="text-gray-700 text-sm leading-relaxed mb-6 italic">
                  „{t.quote}"
                </p>

                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 bg-teal-100 rounded-full flex items-center justify-center text-teal-700 font-bold text-sm flex-shrink-0">
                    {t.initials}
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="font-semibold text-gray-900 text-sm truncate">{t.name}</p>
                    <p className="text-xs text-gray-500 truncate">{t.role}</p>
                  </div>
                  <span className={`text-xs font-bold px-2 py-1 rounded-full flex-shrink-0 ${t.planColor}`}>
                    {t.plan}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── Final CTA ──────────────────────────────────────────────────── */}
      <section className="py-24 bg-teal-700 relative overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-0 left-0 w-96 h-96 bg-white rounded-full blur-3xl"></div>
          <div className="absolute bottom-0 right-0 w-96 h-96 bg-white rounded-full blur-3xl"></div>
        </div>

        <div className="max-w-3xl mx-auto text-center px-4 sm:px-6 lg:px-8 relative z-10">
          <h2 className="text-4xl md:text-5xl font-extrabold text-white mb-6">
            Gata să fii descoperit de noi clienți?
          </h2>

          <p className="text-xl text-teal-100 mb-10 leading-relaxed">
            Înregistrează centrul tău gratuit și testează 30 de zile fără costuri.
          </p>

          <Link
            to="/business/register"
            className="inline-flex items-center gap-3 bg-white text-teal-700 px-10 py-5 rounded-2xl font-bold hover:bg-teal-50 transition-all shadow-2xl text-lg"
          >
            Înregistrează-te acum
            <ArrowRight className="w-5 h-5" />
          </Link>

          <div className="flex flex-wrap justify-center gap-6 mt-10 text-teal-200 text-sm">
            <div className="flex items-center gap-2">
              <Shield className="w-4 h-4" />
              Date securizate GDPR
            </div>
            <div className="flex items-center gap-2">
              <BadgeCheck className="w-4 h-4" />
              Fără comision per programare
            </div>
            <div className="flex items-center gap-2">
              <TrendingUp className="w-4 h-4" />
              Statistici în timp real
            </div>
          </div>
        </div>
      </section>

      {/* ── Footer ─────────────────────────────────────────────────────── */}
      <footer className="bg-gray-900 text-white py-10">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-6">
            <div className="flex items-center gap-3">
              <div className="w-8 h-8 bg-teal-600 rounded-lg flex items-center justify-center">
                <Dumbbell className="w-4 h-4 text-white" />
              </div>
              <div>
                <span className="font-bold text-white">FII FIT Business</span>
                <p className="text-xs text-gray-400">Platforma pentru profesioniști din fitness</p>

              </div>
            </div>

            <div className="flex items-center gap-6 text-sm text-gray-400">
              <Link to="/terms" className="hover:text-white transition-colors">Termeni</Link>
              <Link to="/privacy" className="hover:text-white transition-colors">GDPR</Link>
              <Link to="/contact" className="hover:text-white transition-colors">Suport</Link>
              <Link to="/" className="hover:text-white transition-colors flex items-center gap-1">
                <ChevronRight className="w-3 h-3" />
                FII FIT Clienți

              </Link>
            </div>
          </div>

          <div className="border-t border-gray-800 mt-8 pt-6 text-center text-xs text-gray-500">
            © {new Date().getFullYear()} FII FIT Business. Toate drepturile rezervate.
          </div>
        </div>
      </footer>
    </div>
  );
}
